<template>
  <section>
    <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
      Confirm your ELDs connected to Trucker Tools.
    </h4>
    <div
      v-if="carrierElds?.length > 0"
      class="flex flex-col gap-4"
    >
      <ul
        v-for="(i, idx) in carrierElds"
        :key="idx"
      >
        <li class="integration-btn cursor-pointer">
          <trucker-logo :logo="i" />
          <p class="text-gray-over-dark">Connected</p>
        </li>
      </ul>
    </div>
    <div v-else>
      <p class="rounded-md bg-off-white p-4 text-gray-over-dark">
        Looks like we don’t have any ELD connections on file.
      </p>
    </div>
    <br />
    <button-main
      variant="secondary"
      class="flex items-center justify-center"
      @click="handleAddEldProvider"
    >
      Add New
      <span class="ml-1 text-xl">+</span>
    </button-main>
  </section>
  <add-eldprovider-modal
    :visible="isOnEldProviderModal"
    @click-outside-modal="handleCloseModal()"
    @close="handleCloseModal()"
  />
</template>

<script>
import ButtonMain from '@/components/Button.vue';
import AddEldProviderModal from '@/components/modals/AddEldProviderModal.vue';
import truckerToolLogo from '@/components/truckerToolLogo.vue';
export default {
  name: 'EldsConnected',
  components: {
    'button-main': ButtonMain,
    'add-eldprovider-modal': AddEldProviderModal,
    'trucker-logo': truckerToolLogo,
  },
  data() {
    return {
      isOnEldProviderModal: false,
    };
  },
  computed: {
    carrierElds() {
      return this.$store.state.integrations?.truckerTools?.carrierElds;
    },
    channelId() {
      return this.$store.state.integrations?.truckerTools?.channelId;
    },
  },
  async mounted() {
    this.$store.dispatch('integrations/getAvailableEldTypes', this.channelId);
  },
  methods: {
    handleAddEldProvider() {
      this.isOnEldProviderModal = true;
    },
    handleCloseModal() {
      this.isOnEldProviderModal = false;
    },
  },
};
</script>

<style>
.integration-btn {
  @apply flex items-center justify-between rounded-md border border-light-gray p-2;
  height: 54px;
}
</style>
